import React, { ReactElement } from "react";

interface TabContentProps {
  className?: string;
  children: React.ReactNode;
  id?: string;
  "aria-hidden"?: boolean;
  "aria-describedby"?: string;
}

const TabContent: React.FC<TabContentProps> = ({
  className,
  children,
  id,
  "aria-hidden": ariaHidden,
  "aria-describedby": ariaDescribedby,
}) => {
  return (
    <div
      id={id}
      className={className}
      role="tabpanel"
      aria-hidden={ariaHidden}
      aria-describedby={ariaDescribedby}
    >
      {React.Children.map(children, (child) => {
        return React.cloneElement(child as ReactElement, { isTabSet: true });
      })}
    </div>
  );
};

TabContent.displayName = "TabContent";

export default TabContent;
